import toBoolean from 'to-boolean';
import { datadogLogs, LogsEvent } from '@datadog/browser-logs';

datadogLogs.init({
  clientToken: process.env.DATADOG_CLIENT_TOKEN as string,
  forwardErrorsToLogs: toBoolean(
    process.env.DATADOG_BROWSER_LOGS_ENABLED ?? ''
  ),
  beforeSend(log: LogsEvent) {
    const ignoreErrorPatterns = [
      /^Script error\.$/,
      /^Uncaught "Object Not Found Matching Id:[0-9]+"$/,
      /\[OptinMonster\]/,
    ];

    if (
      ignoreErrorPatterns.some((errorPattern) => errorPattern.test(log.message))
    ) {
      return false;
    }

    return true;
  },
});

datadogLogs.addLoggerGlobalContext('service', 'bonjoro');
datadogLogs.addLoggerGlobalContext('env', process.env.NODE_ENV);
datadogLogs.addLoggerGlobalContext('host', document.location.host);

if (window.Bonjoro?.user) {
  datadogLogs.addLoggerGlobalContext('user_id', window.Bonjoro.user.id);
}
